<template>
  <el-input
      :style="style"
      v-model="nowName"
      placeholder="请选择"
      @focus="open"
      @click="open"
  ></el-input>
  <el-drawer v-model="dialogFormVisible" placement="right" :width="300" trigger="hover">
    <el-scrollbar height="800px">
      <el-tree
          style="color: #000"
          ref="tree"
          class="tree"
          highlight-current:true
          :data="data"
          node-key="id"
          :props="defaultProps"
          :check-strictly=true
          :default-expand-all=true
          @node-click="handleNodeClickEdit"
      >
        <template #default="{ node }">
                <span class="custom-tree-node">
                  <span style="color: #000">{{ node.label }}</span>
                </span>
        </template>
      </el-tree>
    </el-scrollbar>
  </el-drawer>
</template>
<script>

export default {
  name: "multiple depart select",
  data() {
    return {
      showModel: '',
      dialogFormVisible: false,
      nowId: '',
      nowName: '',
    }
  },
  props: [
    'model',
    'keys',
    'style',
    'data',
    'defaultProps'//tree格式
  ],
  created() {

  },
  mounted() {
    if (this.keys != null)
      this.$refs.tree.setCheckedKeys(JSON.parse(this.keys), false)
  },
  methods: {
    handleNodeClickEdit(e) {
      this.nowId = e.id
      // this.nowName = e[this.defaultProps.label]
      this.getName(this.data)
      this.$emit('id', this.nowId)
      this.$emit('name', this.nowName)

      console.log(this.nowId, this.nowName, this.defaultProps, e[this.defaultProps.label])
    },
    open() {
      this.dialogFormVisible = true
    },
    getName(dataArr) {
      dataArr.forEach(i => {
        if (i.id + '' == this.nowId) this.nowName = i[this.defaultProps.label]
        if (i.children) this.getName((i.children))
      })
    }
  },
  watch: {
    'model'(e) {
      this.nowId = e
      this.getName(this.data)
    },
    'dialogFormVisible'(e) {
      if (e && !(this.nowName != '' || this.nowName!= null)) {
        this.nowId = ''
        this.nowName = ''
      }
    },
    'nowId'(e) {
      if (e == null || e == '') this.nowName = ''
    },
  }
}
</script>

<style scoped>

</style>
